    
<div class = "settings-container" >
    <h2>{{ 'userSettings.title' | translate }}</h2>
    <div class = "row" style = "margin-left: 0px;">
        <h4>{{ 'userSettings.profileImage.title' | translate }}</h4>
    </div>
    <div class = "row" style = "margin-left: 0px;">
        {{ 'userSettings.profileImage.instruction' | translate }}
    </div>

    <div class="row" style="margin-left: 0px; margin-top:10px;">
        <!-- Image that will trigger the file input -->
        <img [src]="currentProfileImageUrl" alt="Profile Picture" style="cursor: pointer; width: 100px; height: 100px; border-radius: 50%;" (click)="triggerFileInput()">
        
        <!-- Hidden file input -->
        <input #fileInput type="file" style="display: none;" (change)="onFileSelected($event)">
    </div>
    <div class = "row" style = "margin-left: 0px;margin-top:15px">
        <button class = "btn btn-primary btn-block" style = "width: 100px;" (click)="onUpload()" [disabled] = "!this.selectedFile">{{ 'userSettings.profileImage.upload' | translate }}</button>
    </div>




    <h4 style = "margin-top: 60px;">{{ 'userSettings.changePassword.title' | translate }}</h4>
    <div class = "row" style = "margin-left: 0px;margin-top:15px">
        <label  for="currentPassword">{{ 'userSettings.changePassword.currentPassword' | translate }}</label>
    </div>
    <div class = "row" style = "margin-left: 0px;" style = "margin-left: 0px;">
        <input class = "nameInput" type="password" id="currentPassword" [(ngModel)]="currentPassword" name="currentPassword">
    </div>
    <div class = "row" style = "margin-left: 0px;" style = "margin-left: 0px;margin-top:15px">
        <label  for="newPassword">{{ 'userSettings.changePassword.newPassword' | translate }}</label>
    </div>    
    <div class = "row" style = "margin-left: 0px;" style = "margin-left: 0px">
        <input class = "nameInput" type="password" id="newPassword" [(ngModel)]="newPassword" name="newPassword">
    </div>
    <div class = "row" style = "margin-left: 0px;" style = "margin-left: 0px;margin-top:15px;">
        <button class = "btn btn-primary btn-block" type="submit" (click)="changePassword()" style = "width: 150px;">{{ 'userSettings.changePassword.button' | translate }}</button>
    </div>
    <div class = "row" style = "margin-left: 0px;" style = "margin-left: 0px;margin-top:15px;color: red" *ngIf = "errorPass">
        {{ 'userSettings.changePassword.error' | translate }}
    </div>

    <h4 style = "margin-top: 60px;">{{ 'userSettings.language.title' | translate }}</h4>

    <div class = "row" style = "margin-left: 0px;">
        <mat-form-field appearance="fill" class="password-field" style="margin-top: 15px;">
            <mat-label for="language">{{ 'common.labels.language' | translate }}</mat-label>
            <mat-select [(ngModel)]="language" name="language" (valueChange)="cambiarIdioma($event)" [value]="language">
                <mat-option value="es">{{ 'common.labels.spanish' | translate }}</mat-option>
                <mat-option value="en">{{ 'common.labels.english' | translate }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    
    

    
</div>
